import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'
import Stack from '@mui/material/Stack'

type Props = {
    rowsNum: number
    colsNum: number
    height: number
}

export default function TableSkeleton({ rowsNum, colsNum, height }: Props) {
    return (
        <Stack>
            {[...Array(rowsNum)].map((_, index) => (
                <Box key={index} sx={{ display: 'flex', width: '100%' }}>
                    {[...Array(colsNum)].map((_, rowIndex) => (
                        <Box key={rowIndex} sx={{ flex: '1 0 auto', border: '1px solid white' }}>
                            <Skeleton animation="wave" variant="rectangular" height={height} />
                        </Box>
                    ))}
                </Box>
            ))}
        </Stack>
    )
}
